/* unplugin-vue-components disabled */import { render } from "./Classification.vue?vue&type=template&id=15848a04&scoped=true"
import script from "./Classification.vue?vue&type=script&lang=js"
export * from "./Classification.vue?vue&type=script&lang=js"

import "./Classification.vue?vue&type=style&index=0&id=15848a04&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15848a04"]])

export default __exports__